import { difference, every, union } from "lodash";
import ShareButton from "PFApp/components/activity_share/share_button";
import { Button } from "PFComponents/button";
import Checkbox from "PFComponents/checkbox/checkbox";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./bulk_actions_header.module.scss";

const BulkActionsHeader = ({
  total,
  selectedIds,
  itemsIds,
  setSelectedIds,
  allowSelectAll,
  setSelectMode,
  activityType
}) => {
  const { t } = useTranslation("workflow");

  const allSelected = every(itemsIds, (value) => selectedIds.includes(value));

  const handleSelectAll = () =>
    setSelectedIds(() => {
      if (allSelected) {
        return setSelectedIds(difference(selectedIds, itemsIds)) || [];
      } else {
        return union(itemsIds, selectedIds);
      }
    });

  const handleCancel = () => {
    setSelectMode(null);
    setSelectedIds([]);
  };

  return (
    <div className={css.container}>
      {allowSelectAll && <Checkbox checked={allSelected} handleChange={handleSelectAll} />}
      <ShareButton
        activityIds={selectedIds}
        classes={{ root: css.shareButton }}
        activityType={activityType}
      />
      <Button kind="secondary" onClick={handleCancel}>
        {t("translation:cancel")}
      </Button>
      {allowSelectAll && (
        <div className={css.info}>
          {t("parts.countOfTotalSelected", { count: selectedIds.length, total })}
        </div>
      )}
    </div>
  );
};

BulkActionsHeader.propTypes = {
  total: PropTypes.number.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  setSelectedIds: PropTypes.func.isRequired,
  setSelectMode: PropTypes.func.isRequired,
  allowSelectAll: PropTypes.bool.isRequired,
  activityType: PropTypes.string
};

export default BulkActionsHeader;
